import { render, staticRenderFns } from "./InputSelectBox.vue?vue&type=template&id=6b850abd&scoped=true&"
import script from "./InputSelectBox.vue?vue&type=script&lang=js&"
export * from "./InputSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./InputSelectBox.vue?vue&type=style&index=0&id=6b850abd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b850abd",
  null
  
)

export default component.exports